












import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {PMStrategyMini, Questionnaire, Topix} from '@/domain/Questionnaire'

export interface StrategyItem {
  strategy?: Topix | PMStrategyMini
  riskRank?: number
  returnRank?: number
  no?: number
}

@Component
export default class QuestionnaireGrid extends Vue {
  private strategies: StrategyItem[] = Array<StrategyItem>()
  private selectedItem: StrategyItem = {strategy: undefined}

  @Prop()
  private q?: Questionnaire

  @Watch('q')
  public onChangeQuestionnaire() {
    this.updateRanking()
  }

  public select(candidates: PMStrategyMini) {
    const item = this.strategies.filter((e) => e.strategy === candidates).shift()
    if (!item) {
      return
    }
    this.selectStrategy(item)
  }

  get count() {
    return this.strategies.length
  }

  get cells() {
    if (!this.q) {
      return []
    }
    const cellItems: Array<StrategyItem | undefined> = Array<StrategyItem>()
    for (let y = 0; y < this.strategies.length; y++) {
      for (let x = 0; x < this.strategies.length; x++) {
        const cells = this.strategies.filter((element) => element.returnRank === y && element.riskRank === x)
        if (cells.length) {
          Array.prototype.push.apply(cellItems, cells)
        } else {
          cellItems.push(undefined)
        }
      }
    }
    return cellItems
  }

  private selectStrategy(item: StrategyItem) {
    this.selectedItem = item
    this.$emit('select', item)
  }

  private updateRanking() {
    if (!this.q) {
      return
    }
    Array.prototype.push.apply(this.strategies, this.q.candidates.map((s, i) => ({
      strategy: s,
      no: i + 1,
    } as StrategyItem)))
    this.strategies.push({strategy: this.q.topix} as StrategyItem)
    this.strategies.sort((a, b) =>
        this.compare(parseFloat(b.strategy!.risk), parseFloat(a.strategy!.risk))).map((s, i) => s.riskRank = i,
    )
    this.strategies.sort((a, b) =>
        this.compare(parseFloat(a.strategy!.return), parseFloat(b.strategy!.return))).map((s, i) => s.returnRank = i,
    )
  }

  private compare(a: number, b: number) {
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    return 0
  }
}
